import OwLabel from "@components/shared/OwLabel/OwLabel";
import IRelatedOrder from "@models/IRelatedOrder";
import React from "react";
import { Link } from "react-router-dom";

type Props = {
    relatedOrders: IRelatedOrder[];
};

export const RelatedOrdersPanel = (props: Props) => {
    return (
        <div className={"RelatedOrdersPanel p-2"}>
            {props.relatedOrders.map((relatedOrder) => {
                let prefix = "orders";

                if (relatedOrder.is_quote) {
                    prefix = "quotes";
                }

                if (relatedOrder.is_template) {
                    prefix = "templates";
                }

                return (
                    <div key={relatedOrder.guid}>
                        <Link to={`/${prefix}/${relatedOrder.guid}/entry`}>{relatedOrder.name}</Link>
                    </div>
                );
            })}
        </div>
    );
};
